import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledAllNewProducts = styled('div')`
  .products-inner {
    background-color: ${({ theme }) => theme.whiteSmoke};
  }

  .product-name-bread-wrapper {
    background-color: ${({ theme }) => theme.whiteSmoke};
  }

  .product-name-and-qmarks-container {
    .product-name {
      margin-top: 0 !important;
    }
  }

  .products-filters-container {
    display: flex;
    flex-direction: row;
    column-gap: 50px;

    .ant-select-selector {
      border: 1px solid ${({ theme }) => theme.borderBottom};
    }

    .ant-select-selection-placeholder {
      color: ${({ theme }) => theme.colorText} !important;
      font-size: 16px;
      line-height: 28px;
    }

    .form-container {
      margin-top: 40px;
    }
  }

  .ant-pagination-item {
    margin-right: 0;
  }

  .ant-pagination-prev {
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 24px;
  }

  .discount-items {
    display: none;
  }

  .popular-categories {
    padding-bottom: 50px;
    padding-top: 100px;

    h1 {
      margin-bottom: 19px;
    }
  }

  .banners {
    padding-bottom: 39px;
    background-color: ${({ theme }) => theme.white};

    .slick-slider {
      margin-bottom: 0;

      .banner-image-wrapper {
        padding: 0;
      }

      .slick-dots-bottom {
        bottom: -32px;
      }
    }

    .banner-wrapper:first-child {
      .slick-dots-bottom {
        bottom: -20px;
      }
    }

    .banner-wrapper {
      padding: 21px 0;
    }
  }

  .products-filters-container {
    display: flex;
    flex-direction: row;

    .ant-form {
      padding-right: 0;
    }

    .ant-select-selector {
      background-color: ${({ theme }) => theme.lightGrey} !important;
    }

    .ant-spin-nested-loading {
      width: 100%;
      justify-content: center;
    }

    .products-wrapper {
      .products {
        flex-wrap: wrap;
        padding-top: 40px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 20px;
        justify-content: center;
        justify-items: center;
      }
    }
    .category_name {
      display: none;
    }

    .pagination {
      display: flex;
      justify-content: center;
      padding: 77px 0 83px 0;

      li {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        font-family: ${({ theme }) => theme.fontText} !important;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .products-filters-container {
      .products-wrapper {
        padding-right: 0;
      }
    }
    .form-container {
      display: none;
    }
    .products-wrapper {
      padding-right: 0;
      .products {
        justify-content: center !important;
        padding: 0;
      }
      .category_name {
        text-align: center;
        display: block;
        font-size: 1.125rem;
        font-weight: 600;
      }
    }
  }

  .ant-pagination-prev {
    margin-inline-end: 24px !important;
  }

  .ant-pagination-next {
    margin-inline-start: 24px !important;
  }

  .ant-pagination-item {
    margin-right: 0;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .products-container {
      background-color: ${({ theme }) => theme.inputGrey};
    }

    .popular-categories {
      padding-bottom: 0;
      padding-top: 0;
    }

    .mobile-product-category {
      padding: 20px 0 44px 0;

      .title {
        padding: 0 20px;

        h1 {
          margin-top: 0;
        }
      }

      .slick-dots-bottom {
        bottom: -22px !important;
      }
    }

    .products-container {
      background-color: ${({ theme }) => theme.inputGrey};
    }

    .discount-items {
      display: block;
      padding-top: 25px;
      background-color: ${({ theme }) => theme.brightGrey};

      .slick-dots-bottom {
        bottom: 0;
      }
    }

    .banners {
      padding-bottom: 0;
      background-color: ${({ theme }) => theme.brightGrey};

      .desktop-banner {
        display: block;
      }

      .slick-dots {
        display: none !important;
      }

      .banner-wrapper {
        padding-top: 0;
      }
      .desktop-banner:first-child {
        padding-bottom: 21px;
      }
    }

    .ant-pagination-prev {
      margin-inline-end: 6px !important;
    }

    .ant-pagination-next {
      margin-inline-start: 6px !important;
    }

    .products-filters-container {
      .products-wrapper {
        .products {
          padding-top: 0;
          grid-template-columns: 1fr;
          gap: 15px;
        }

        .category_name {
          text-align: start;
        }
      }

      .pagination {
        padding: 15px 0 33px 0 !important;
      }
    }

    .ant-pagination-prev {
      margin-right: 6px;
    }

    .ant-pagination-next {
      margin-left: 6px;
    }
  }
`;
